export default "/images/29bea6cb38a0eb3639eb2c09720e4fa7.avif";